import styled from '@emotion/styled';
import { tokens } from '@hotjar/hotsauce';

interface DigitProps {
  valid?: boolean;
  hasError?: boolean;
  shouldRenderSeparator?: boolean;
}

const getColor = (hasError: boolean | undefined, isValid: boolean | undefined) => {
  if (hasError) return tokens.color.magenta_600;
  return isValid ? tokens.color.mint_500 : tokens.color.neutral_300;
};

export const Digit = styled('input')<DigitProps>`
  width: 13%;
  height: 50px;
  font-size: 22px;
  font-weight: 400;
  text-align: center;
  padding: 0;
  margin: 0 ${tokens.spacer.x1} 0 0;
  ${({ shouldRenderSeparator }) => shouldRenderSeparator && `margin-right: ${tokens.spacer.x3} ;`}
  color: ${tokens.color.neutral_700};
  border-radius: 4px;
  border: 1px solid ${({ hasError, valid }) => getColor(hasError, valid)};
  caret-color: ${({ hasError, valid }) => getColor(hasError, valid)};

  &:hover {
    opacity: 0.9;
  }

  &:focus {
    border-color: ${(props) => getColor(props.hasError, true)};
    caret-color: ${(props) => getColor(props.hasError, true)};
  }

  &:last-of-type {
    margin-right: 0;
  }

  @media (min-width: 480px) {
    height: 70px;
  }

  @media (min-width: 768px) {
    width: 60px;
    font-size: 28px;
  }
`;
